import axios from "axios";

const axiosInstance = axios.create({
    // baseURL: "https://your-api-url.com", // optional
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("access_token");
        const role = localStorage.getItem("role");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (role) {
            config.headers.Role = role;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosInstance;